import * as Yup from 'yup';
import i18n from 'i18next';
import isFQDN from 'validator/es/lib/isFQDN.js';


const minMsgLength = 5;
const text_domain_invalid = i18n.t('widget.validation.add_right_domain');
const text_comment_min = i18n.t('validation.comment_min', { minLength: minMsgLength });

const schemaAddDomain = Yup.object().shape({
    domain: Yup.string()
        .required()
        .min(minMsgLength, text_comment_min)
        .test('is-valid-domain', text_domain_invalid, (value) => {
            return isFQDN(value || '', { require_tld: true });
        }),
});

export default schemaAddDomain;
